export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("T")[0].split("-");
  return `${d}/${m}/${y}`;
};

export const todayISO = () => new Date().toISOString().split("T")[0];

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? fmtDate(iso)
    : d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "America/Sao_Paulo" });
};

export const maskDocument = (value) => {
  const d = (value || "").replace(/\D/g, "").slice(0, 14);
  if (d.length <= 11) {
    return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return d.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

export const fmtMonthLabel = (m) => {
  if (!m) return "";
  const MESES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  const [y, mm] = m.split("-");
  return `${MESES[parseInt(mm) - 1]}/${y}`;
};

export const STATUS_STYLES = {
  "A Pagar": "text-amber-400 bg-amber-400/10 border-amber-400/20",
  Pendente: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  Pago: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  Atrasado: "text-rose-400 bg-rose-400/10 border-rose-400/20",
  Ativo: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  Inativo: "text-zinc-400 bg-zinc-400/10 border-zinc-400/20",
  "Em processamento": "text-sky-400 bg-sky-400/10 border-sky-400/20",
  Separado: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  Enviado: "text-indigo-400 bg-indigo-400/10 border-indigo-400/20",
  "Concluído": "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  "Pago Parcialmente": "text-amber-400 bg-amber-400/10 border-amber-400/20",
  "Pago Parcial": "text-amber-400 bg-amber-400/10 border-amber-400/20",
  Liquidado: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  "Em aberto": "text-sky-400 bg-sky-400/10 border-sky-400/20",
  Aprovado: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  Recusado: "text-rose-400 bg-rose-400/10 border-rose-400/20",
  Convertido: "text-indigo-400 bg-indigo-400/10 border-indigo-400/20",
};

export const PAYMENT_METHODS = ["PIX", "Boleto", "Cartão de Crédito", "Cartão de Débito", "Dinheiro", "Cheque"];
export const ORDER_STATUSES = ["Em processamento", "Separado", "Enviado", "Concluído"];
